/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const EXCEL_ERRORS = {
	DIV0: '#DIV0',
	NA: '#NA!',
	NAME: '#NAME?',
	NUM: '#NUM!',
	REF: '#REF!',
	VALUE: '#VALUE!'
};
const ERRORS = {
	ABORTED: '#ABORTED',
	ARGS: '#ARG_NUM',
	CONNECTION: '#CONNECTION',
	DISCONNECTED: '#DISCONNECTED',
	ERR: '#ERR',
	EXECUTE: '#EXECUTE',
	FUNC_EXEC: '#FUNC_EXEC',
	INVALID_LOOP_PATH: '#INVALID_LOOP_PATH',
	INVALID_PARAM: '#INVALID_PARAM',
	INVALID_PATH: '#INVALID_PATH',
	INTERNAL: '#INTERNAL',
	LIMIT: '#LIMIT',
	NO_INTEGRATION: '#NO_INTEGRATION_SELECTED',
	// TODO: remove -> machine always exists
	NO_MACHINE: '#NO_MACHINE',
	NO_MACHINE_HTTP_SERVER: '#NO_HTTP_SERVER_MACHINE',
	NO_MACHINE_OPCUA: '#NO_OPCUA_MACHINE',
	NO_MSG: '#NO_MSG',
	NO_MSG_DATA: '#NO_MSG_DATA',
	NO_STREAMSHEET: '#NO_STREAMSHEET',
	RANGE: '#RANGE',
	RESPONSE: '#RESPONSE',
	WAITING: '#WAITING'
	
	// DEPRECATED:	
	// NULL: '#NULL',
	// ,INVALID: 'INVALID'
	// ,NO_CONSUMER: '#NO_CONSUMER',
	// NO_PRODUCER: '#NO_PRODUCER',
	// LIST: '#NO_LIST',
	// NO_MSG_ID: '#NO_MSG_ID',
	// OUTBOX: '#NO_OUTBOX',
	// NO_TOPIC: '#NO_TOPIC',
	// PROCSHEET: '#PROCESS_SHEET',
	// RANGE_INVALID: '#RANGE_INVALID',
	// SELF_REF: '#SELF_REF',
	// SOURCE: '#SOURCE',
	// TARGET: '#TARGET',
	// TOPIC_INVALID: '#TOPIC_INVALID',
	// TYPE_PARAM: '#TYPE_PARAM',
};
module.exports = { ...EXCEL_ERRORS, ...ERRORS };
